import { useLocation, useNavigate } from "react-router-dom";

/**
 * Hook to get and set a query parameter
 */
const useQueryParam = (key) => {
    const location = useLocation();
    const navigate = useNavigate();

    const getParam = () => {
        const params = new URLSearchParams(location.search);
        return params.get(key);
    };

    const setParam = (value) => {
        const params = new URLSearchParams(location.search);

        if (value === null || value === undefined || value === 'all') {
            params.delete(key);
        } else {
            params.set(key, value);
        }

        navigate({
            pathname: location.pathname,
            search: params.toString(),
        }, { replace: true });
    };

    return [getParam(), setParam];
};

export default useQueryParam;
